import { buildTemplateWorkbook, downloadWorkbook } from './spreadsheet-template.utils';

export const REFUND_PAYMENTS_TEMPLATE_FILENAME = 'plantilla-pagos-reembolsos.xlsx';

/**
 * Headers of the refunds "Cargar pagos" template. They match the column detection of
 * `RefundView` (`parsePaymentFile`): the first one contains "n°"/"solicitud", the second
 * "fecha"/"pago".
 */
export const REFUND_PAYMENTS_TEMPLATE_HEADERS = ['N° de solicitud', 'Fecha de pago'];

const COLUMNS = [
  { header: REFUND_PAYMENTS_TEMPLATE_HEADERS[0], width: 18, note: 'El n° de la solicitud de reembolso.' },
  { header: REFUND_PAYMENTS_TEMPLATE_HEADERS[1], width: 16, note: 'DD/MM/AAAA, DD-MM-AAAA, DD.MM.AAAA o AAAA-MM-DD.' }
];

const EXAMPLES = [
  ['1234', '15/10/2026'],
  ['1235', '15/10/2026']
];

/** Workbook of the refunds "Cargar pagos" template ("Pagos" to fill in, "Ejemplo" filled). */
export function buildRefundPaymentsTemplate() {
  return buildTemplateWorkbook({ sheetName: 'Pagos', columns: COLUMNS, examples: EXAMPLES });
}

/** Saves the refunds "Cargar pagos" template as an .xlsx file. */
export async function downloadRefundPaymentsTemplate() {
  await downloadWorkbook(await buildRefundPaymentsTemplate(), REFUND_PAYMENTS_TEMPLATE_FILENAME);
}
